module.exports = __webpack_public_path__ + "img/logo.a5e031e8.svg";